import { render, staticRenderFns } from "./WorkspaceCreate.vue?vue&type=template&id=ef5d76f6&lang=html"
import script from "./WorkspaceCreate.vue?vue&type=script&lang=js"
export * from "./WorkspaceCreate.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceCreate.vue?vue&type=style&index=0&id=ef5d76f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports